import type { IconData } from '@stacksjs/iconify-core'

export const cloudOffSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.518 4.232a2.5 2.5 0 0 0-3.536 3.536l38 38a2.5 2.5 0 0 0 3.536-3.536l-2.571-2.57q.555-.425 1.051-.91C45.207 36.591 46.5 33.573 46.5 30c0-5.631-3.21-9.85-8.062-11.533c-.304-3.676-1.704-6.865-4-9.165c-2.368-2.373-5.66-3.771-9.598-3.799a118 118 0 0 0-1.68 0c-3.938.028-7.23 1.426-9.598 3.799q-.495.495-.932 1.043zm3.044 14.235l.003-.03l23.91 23.91c-2.592.093-5.72.153-9.475.153c-4.087 0-7.43-.071-10.15-.18c-3.552-.14-6.642-1.413-8.848-3.569C2.794 36.592 1.5 33.574 1.5 30c0-5.631 3.21-9.85 8.062-11.533\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default cloudOffSolid
